import React, { useState } from "react";
import Table from "../UI/Table";
import Button from "../UI/Button";
import {
  resendRecipient,
  resendFailedForEvent,
  checkTaskStatus,
} from "../../services/emailEventService";
import { toast } from "react-toastify";

/**
 * Displays failed recipients only
 */

const EmailRecipientTable = ({ recipients, eventId, refresh }) => {
  const [resendingAll, setResendingAll] = useState(false);
  const [resendingId, setResendingId] = useState(null);

  const handleResendSingle = async (recipientId) => {
    try {
      setResendingId(recipientId);
      const response = await resendRecipient(recipientId);

      if (response.data.status === 1) {
        toast.success("Email resent successfully");
      } else {
        toast.error(response.data.message || "Resend failed");
      }
      refresh();
    } catch {
      toast.error("Resend failed");
    } finally {
      setResendingId(null);
    }
  };

  const handleResendAll = async () => {
    try {
      setResendingAll(true);

      const response = await resendFailedForEvent(eventId);
      const taskId = response.data.task_id;

      toast.info("Resend task started...");


      const interval = setInterval(async () => {
        try {
          const res = await checkTaskStatus(taskId);

          if (res.state === "SUCCESS") {
            clearInterval(interval);
            clearTimeout(timeout);

            const result = res.result;

            if (result.total_success > 0 && result.total_failed === 0) {
              toast.success(
                `All ${result.total_success} emails resent successfully`
              );
            } else if (result.total_success > 0 && result.total_failed > 0) {
              toast.warning(
                `Partial resend: ${result.total_success} sent, ${result.total_failed} failed`
              );
            } else {
              toast.error(
                `Resend failed for all ${result.total_failed} emails`
              );
            }

            refresh();
            setResendingAll(false);
          }

          if (res.state === "FAILURE") {
            clearInterval(interval);
            clearTimeout(timeout);
            toast.error("Resend task crashed");
            setResendingAll(false);
          }

        } catch (err) {
          clearInterval(interval);
          clearTimeout(timeout);
          toast.error("Error checking task status");
          setResendingAll(false);
        }

      }, 3000);

      // TIMEOUT SAFETY (15 seconds)
      const timeout = setTimeout(() => {
        clearInterval(interval);
        toast.error(
          "Task not started. Is Celery running?"
        );
        setResendingAll(false);
      }, 15000);

      // const interval = setInterval(async () => {
      //   const res = await checkTaskStatus(taskId);
      //   if (res.state === "SUCCESS") {
      //     clearInterval(interval);

      //     const result = res.result;

      //     if (result.total_failed > 0) {
      //       toast.error(
      //         `Resend completed with failures. Failed: ${result.total_failed}`
      //       );
      //     } else {
      //       toast.success(
      //         `Resend successful. Sent: ${result.total_success}`
      //       );
      //     }

      //     refresh();
      //     setResendingAll(false);
      //   }

      //   if (res.state === "FAILURE") {
      //     clearInterval(interval);
      //     toast.error("Resend failed");
      //     setResendingAll(false);
      //   }
      // }, 3000);

    } catch {
      toast.error("Failed to start resend task");
      setResendingAll(false);
    }
  };

  if (!recipients || recipients.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        No Failed Emails
      </div>
    );
  }

  const columns = [
    { header: "Email", accessor: "email" },
    { header: "Retries", accessor: "retry_count" },
    {
      header: "Error",
      render: (row) => (
        <span className="text-xs text-red-600 break-words">
          {row.error_message || "-"}
        </span>
      ),
    },
    // {
    //   header: "Sent",
    //   render: (row) =>
    //     row.sent_at
    //       ? new Date(row.sent_at).toLocaleString()
    //       : "-",
    // },
    {
      header: "Action",
      render: (row) => (
        <Button
          variant="primary"
          loading={resendingId === row.id}
          onClick={() => handleResendSingle(row.id)}
        >
          Resend
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div className="mb-4">
        <Button
          variant="danger"
          loading={resendingAll}
          onClick={handleResendAll}
        >
          Resend All Failed ({recipients.length})
        </Button>
      </div>

      <Table columns={columns} data={recipients} />
    </div>
  );
};

export default EmailRecipientTable;